
const SuccessImage = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="400"
        height="260"
        viewBox="0 0 250 140"
        fill="none"
    >
        <g clipPath="url(#clip0_2381_16393)">
            <g
                opacity="0.3"
                filter="url(#filter0_f_2381_16393)"
            >
                <path
                    d="M167.365 89.3262H87.7598V130.211H167.365V89.3262Z"
                    fill="#195AFE"
                />
            </g>
            <path
                d="M119.684 84.1377L115.969 101.277"
                stroke="url(#paint0_linear_2381_16393)"
                strokeWidth="8.22668"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M127.031 84.1367L130.746 101.276"
                stroke="url(#paint1_linear_2381_16393)"
                strokeWidth="8.22668"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M153.066 42.318C153.066 26.124 139.941 13 123.751 13C107.561 13 94.4341 26.124 94.4341 42.318C94.4341 56.171 105.883 70.666 117.753 80.46H129.747C141.616 70.666 153.066 56.168 153.066 42.318Z"
                fill="url(#paint2_linear_2381_16393)"
            />
            <path
                d="M125.688 13.067C125.046 13.024 124.402 13 123.752 13C123.102 13 122.454 13.024 121.813 13.067C119.139 17.285 115.25 26.775 115.25 42.91C115.25 61.118 120.367 75.345 122.737 80.456H124.761C127.134 75.342 132.248 61.118 132.248 42.91C132.251 26.775 128.362 17.285 125.688 13.067Z"
                fill="url(#paint3_linear_2381_16393)"
            />
            <path
                d="M118.41 13.4863C116.244 13.8843 114.159 14.5233 112.184 15.3703C106.274 20.7253 100.229 30.2573 100.229 43.1083C100.229 61.0213 115.636 76.6863 120.118 80.4573H120.537C114.04 71.5443 106.96 55.5273 106.96 41.9203C106.963 28.6313 114.688 16.7653 118.41 13.4863Z"
                fill="url(#paint4_linear_2381_16393)"
            />
            <path
                d="M147.271 43.1083C147.271 30.2573 141.23 20.7253 135.317 15.3703C133.345 14.5233 131.26 13.8843 129.091 13.4863C132.813 16.7653 140.537 28.6313 140.537 41.9203C140.537 55.5273 133.457 71.5443 126.96 80.4573H127.38C131.862 76.6863 147.271 61.0243 147.271 43.1083Z"
                fill="url(#paint5_linear_2381_16393)"
            />
            <path
                d="M130.518 84.556H116.192C115.842 84.556 115.56 84.21 115.56 83.781V81.235C115.56 80.806 115.842 80.46 116.192 80.46H130.518C130.868 80.46 131.15 80.806 131.15 81.235V83.781C131.153 84.21 130.868 84.556 130.518 84.556Z"
                fill="url(#paint6_linear_2381_16393)"
            />
            <path
                d="M149.322 102.751L100.086 98.1488C98.9388 98.0418 97.9218 98.8838 97.8148 100.03L94.4428 136.118C94.3358 137.264 95.1778 138.282 96.3238 138.388L145.563 142.99C146.71 143.097 147.727 142.256 147.833 141.109L151.206 105.022C151.312 103.875 150.469 102.857 149.322 102.751Z"
                fill="url(#paint7_linear_2381_16393)"
            />
            <path
                d="M122.751 121.309L150.757 103.543C150.415 103.11 149.911 102.804 149.319 102.748L100.083 98.1482C99.5649 98.0992 99.0868 98.2652 98.6938 98.5452L122.751 121.309Z"
                fill="white"
            />
            <path
                d="M122.822 129.473C127.33 129.473 130.985 125.819 130.985 121.31C130.985 116.802 127.33 113.147 122.822 113.147C118.314 113.147 114.659 116.802 114.659 121.31C114.659 125.819 118.314 129.473 122.822 129.473Z"
                fill="url(#paint8_linear_2381_16393)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M124.604 117.337C124.524 117.31 124.443 117.281 124.357 117.256C123.003 116.855 122.25 117.512 122.05 118.19C121.775 119.116 122.243 119.751 123.455 120.684C124.94 121.828 125.555 122.891 125.124 124.348C124.997 124.78 124.784 125.167 124.493 125.487C125.693 124.998 126.67 123.986 127.067 122.645C127.707 120.483 126.617 118.22 124.604 117.337Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M122.496 121.538C121.048 120.487 120.295 119.35 120.708 117.954C120.77 117.747 120.852 117.554 120.953 117.377C119.842 117.894 118.951 118.867 118.576 120.134C118.184 121.457 118.44 122.816 119.158 123.876C119.653 124.482 120.133 124.937 121.106 125.206C122.423 125.569 123.486 125.063 123.781 124.063C124.056 123.137 123.683 122.451 122.496 121.538Z"
                fill="white"
            />
            <g filter="url(#filter1_d_2381_16393)">
                <path
                    d="M92.836 78.5829H90.935V74.8199C90.935 69.0079 86.221 64.2939 80.409 64.2939C76.404 64.2939 72.926 66.5299 71.147 69.8179C69.746 68.5289 67.88 67.7399 65.828 67.7399C61.784 67.7399 58.456 70.7939 58.021 74.7189H55.323C50.174 74.7229 46 78.8959 46 84.0419C46 89.1919 50.174 93.3659 55.323 93.3659H77.211H80.412H92.84C96.923 93.3659 100.229 90.056 100.229 85.976C100.229 81.896 96.916 78.5829 92.836 78.5829Z"
                    fill="white"
                />
            </g>
            <g opacity="0.7">
                <path
                    d="M176.944 103.203L176.626 110.123"
                    stroke="url(#paint9_linear_2381_16393)"
                    strokeWidth="5.14167"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M179.266 102.909L181.295 109.532"
                    stroke="url(#paint10_linear_2381_16393)"
                    strokeWidth="5.14167"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                d="M191.787 77.5301C190.642 68.4601 182.362 62.0371 173.293 63.1831C164.225 64.3281 157.801 72.6081 158.946 81.6781C159.926 89.4381 167.365 96.7471 174.706 101.393L181.424 100.544C187.379 94.2191 192.767 85.2881 191.787 77.5301Z"
                fill="url(#paint11_linear_2381_16393)"
            />
            <g opacity="0.7">
                <path
                    d="M174.383 63.082C174.021 63.104 173.658 63.136 173.294 63.182C172.93 63.228 172.569 63.287 172.213 63.356C171.013 65.908 169.506 71.499 170.648 80.537C171.936 90.735 175.809 98.342 177.498 101.037L178.631 100.894C179.599 97.862 181.457 89.533 180.169 79.334C179.029 70.296 176.179 65.255 174.383 63.082Z"
                    fill="url(#paint12_linear_2381_16393)"
                />
                <path
                    d="M170.336 63.833C169.151 64.209 168.028 64.714 166.982 65.329C164.05 68.746 161.339 74.513 162.248 81.711C163.516 91.744 173.253 99.429 176.031 101.224L176.266 101.194C171.996 96.662 166.897 88.191 165.934 80.569C164.996 73.126 168.483 65.933 170.336 63.833Z"
                    fill="url(#paint13_linear_2381_16393)"
                />
                <path
                    d="M188.597 78.3821C187.688 71.1841 183.629 66.2721 179.938 63.6921C178.774 63.3561 177.561 63.1461 176.318 63.0771C178.635 64.6501 183.801 70.7501 184.741 78.1931C185.704 85.8151 182.871 95.2872 179.862 100.739L180.097 100.709C182.341 98.2802 189.864 88.4181 188.597 78.3821Z"
                    fill="url(#paint14_linear_2381_16393)"
                />
            </g>
            <path
                d="M182.146 102.784L174.121 103.797C173.925 103.822 173.742 103.648 173.712 103.408L173.532 101.982C173.502 101.742 173.635 101.528 173.831 101.503L181.856 100.49C182.052 100.465 182.234 100.639 182.265 100.879L182.445 102.305C182.476 102.545 182.341 102.759 182.146 102.784Z"
                fill="url(#paint15_linear_2381_16393)"
            />
            <path
                d="M174.895 112.862C174.317 110.69 175.786 108.507 178.016 108.226L179.474 108.041C181.704 107.76 183.67 109.509 183.65 111.756C183.633 113.613 182.246 115.172 180.404 115.404L178.946 115.588C177.103 115.821 175.373 114.656 174.895 112.862Z"
                fill="url(#paint16_linear_2381_16393)"
            />
            <g filter="url(#filter2_d_2381_16393)">
                <path
                    d="M162.785 42.8898H162.68V41.4138C162.68 37.2558 159.308 33.8848 155.15 33.8848C151.355 33.8848 148.216 36.6938 147.698 40.3458H144.619C140.77 40.3458 137.647 43.4668 137.647 47.3178C137.647 51.1668 140.768 54.2898 144.619 54.2898H162.785C165.931 54.2898 168.485 51.7388 168.485 48.5898C168.485 45.4408 165.934 42.8898 162.785 42.8898Z"
                    fill="white"
                />
            </g>
            <path
                opacity="0.2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M95.4391 34.6777C94.7831 37.1137 94.4331 39.6747 94.4331 42.3177C94.4331 56.1717 105.883 70.6657 117.752 80.4597H129.746C134.262 76.7337 138.717 72.3267 142.504 67.5327C117.574 68.7467 102.852 49.5617 95.4391 34.6777Z"
                fill="#195AFE"
            />
        </g>
        <defs>
            <filter
                id="filter0_f_2381_16393"
                x="-220.74"
                y="-219.174"
                width="696.605"
                height="657.885"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feGaussianBlur
                    stdDeviation="154.25"
                    result="effect1_foregroundBlur_2381_16393"
                />
            </filter>
            <filter
                id="filter1_d_2381_16393"
                x="4.8666"
                y="23.1605"
                width="136.496"
                height="111.339"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="20.5667" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.2 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_2381_16393"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_2381_16393"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_2381_16393"
                x="96.5136"
                y="-7.24863"
                width="113.105"
                height="102.672"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="20.5667" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.2 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_2381_16393"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_2381_16393"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_2381_16393"
                x1="117.826"
                y1="84.1377"
                x2="117.826"
                y2="101.277"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="0.766504"
                    stopColor="#C9D8FF"
                />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2381_16393"
                x1="128.888"
                y1="84.1367"
                x2="128.888"
                y2="101.276"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#195AFE" />
                <stop
                    offset="0.766504"
                    stopColor="#C9D8FF"
                />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint2_linear_2381_16393"
                x1="113.147"
                y1="78.686"
                x2="146.74"
                y2="19.832"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5384FF" />
                <stop
                    offset="1"
                    stopColor="#B4CAFF"
                />
            </linearGradient>
            <linearGradient
                id="paint3_linear_2381_16393"
                x1="129.869"
                y1="24.821"
                x2="126.012"
                y2="81.563"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint4_linear_2381_16393"
                x1="129.869"
                y1="24.8213"
                x2="126.012"
                y2="81.5633"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint5_linear_2381_16393"
                x1="129.869"
                y1="24.8213"
                x2="126.012"
                y2="81.5633"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint6_linear_2381_16393"
                x1="116.162"
                y1="84.556"
                x2="130.514"
                y2="81.78"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9AB6FB" />
                <stop
                    offset="0.913211"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint7_linear_2381_16393"
                x1="127.793"
                y1="98.1398"
                x2="122.824"
                y2="133.146"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#DCE6FF" />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint8_linear_2381_16393"
                x1="122.822"
                y1="113.147"
                x2="122.822"
                y2="129.473"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF7A1A" />
                <stop
                    offset="1"
                    stopColor="#FFC100"
                />
            </linearGradient>
            <linearGradient
                id="paint9_linear_2381_16393"
                x1="176.357"
                y1="103.277"
                x2="177.213"
                y2="110.049"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6E97FF" />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint10_linear_2381_16393"
                x1="179.853"
                y1="102.835"
                x2="180.708"
                y2="109.607"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#6E97FF" />
                <stop
                    offset="1"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint11_linear_2381_16393"
                x1="172.001"
                y1="100.725"
                x2="186.653"
                y2="65.3831"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF7A1A" />
                <stop
                    offset="1"
                    stopColor="#FEB72B"
                />
            </linearGradient>
            <linearGradient
                id="paint12_linear_2381_16393"
                x1="173.292"
                y1="63.182"
                x2="178.065"
                y2="100.966"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint13_linear_2381_16393"
                x1="165.84"
                y1="64.401"
                x2="170.578"
                y2="101.912"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint14_linear_2381_16393"
                x1="180.813"
                y1="62.5091"
                x2="185.551"
                y2="100.021"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop
                    offset="1"
                    stopColor="white"
                    stopOpacity="0"
                />
            </linearGradient>
            <linearGradient
                id="paint15_linear_2381_16393"
                x1="174.104"
                y1="103.8"
                x2="181.947"
                y2="101.23"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9AB6FB" />
                <stop
                    offset="0.913211"
                    stopColor="white"
                />
            </linearGradient>
            <linearGradient
                id="paint16_linear_2381_16393"
                x1="175.669"
                y1="116.002"
                x2="181.071"
                y2="107.057"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5E8CFF" />
                <stop
                    offset="1"
                    stopColor="#CFDBFA"
                />
            </linearGradient>
            <clipPath id="clip0_2381_16393">
                <rect
                    width="255"
                    height="165"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

export default SuccessImage;
